import { DomSanitizer } from "@angular/platform-browser";
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  standalone: false, name: "safeHtml" })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value:any) {
    
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}